import { render, staticRenderFns } from "./OrderLine.vue?vue&type=template&id=2436ea62&scoped=true&"
import script from "./OrderLine.vue?vue&type=script&lang=js&"
export * from "./OrderLine.vue?vue&type=script&lang=js&"
import style0 from "./OrderLine.vue?vue&type=style&index=0&id=2436ea62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436ea62",
  null
  
)

export default component.exports